// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const bannerAuthResource = '/merchant/notifications/active-banners-auth'
const bannerNoAuthResource = '/notifications/active-banners-no-auths'
const latestBannerAuthResource = '/merchant/notifications/latest-banners-auth'

export default {
  getActiveBannerAuth() {
    return OperationRepository.get(`${bannerAuthResource}`)
  },
  getLatestBannerAuth() {
    return OperationRepository.get(`${latestBannerAuthResource}`)
  },
  getActiveBannerNoAuth() {
    return OperationRepository.get(`${bannerNoAuthResource}`)
  },
}
